import React, { useState } from 'react';
import Logo from '../assets/logo.png';
import { useAlert } from '../AlertContext';

export default function Contact() {
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    Name: '',
    LastName: '',
    Email: '',
    Message: '',
    Subject: '',
  });

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id.charAt(0).toUpperCase() + id.slice(1)]: value, // capitalize first letter
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    console.log(formData)

    try {
      const response = await fetch(
        'https://x95nw9pp7b.execute-api.eu-central-1.amazonaws.com/live/service-email-sender',
        {
          mode:'no-cors',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            ...formData,
            ServiceID: 864,
          }),
        }
      );

      if (response.ok || response.type === "opaque") { // because of no-cors
        showAlert("Your message has been sent successfully!", "success");
      } else {
        showAlert("There was an issue sending your message. Please try again later.", "error");
      }

      setFormData({
        Name: '',
        LastName: '',
        Email: '',
        Message: '',
        Subject: '',
      });

    } catch (error) {
      console.error("❌ Error sending message:", error);
      showAlert("There was an error sending your message. Please try again later.", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div className='header_1'>
        <div className='container d-flex flex-row justify-content-between align-items-center'>
          <img width={90} src={Logo} alt="Logo" />
          <button className='btn btn-primary' onClick={() => window.location.href = '/#login'}>Login</button>
        </div>
      </div>

      <div className='container mb-4' style={{ marginTop: '8rem' }}>
        <h2 className="mb-2 text-light">We'd love to hear from you!</h2>
        <p className='text-light'>If you have any questions, feedback, or inquiries, please reach out to us at:</p>

        <form className="mt-4" style={{ maxWidth: '800px' }} onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="name" className="form-label text-light">Name</label>
            <input
              type="text"
              className="form-control"
              id="name"
              placeholder="Enter your name"
              value={formData.Name}
              onChange={handleChange}
            />
          </div>

          <div className='mb-3' >
          <label htmlFor="lastname" className="form-label text-light">Last Name</label>
            <input
              type="text"
              className="form-control"
              id="lastName"
              placeholder="Enter your name"
              value={formData.LastName}
              onChange={handleChange}
            />

          </div>

          <div className="mb-3">
            <label htmlFor="email" className="form-label text-light">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Enter your email"
              value={formData.Email}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="subject" className="form-label text-light">Subject</label>
            <input
              type="text"
              className="form-control"
              id="subject"
              placeholder="Enter a subject"
              value={formData.Subject}
              onChange={handleChange}
            />
          </div>

          <div className="mb-3">
            <label htmlFor="message" className="form-label text-light">Message</label>
            <textarea
              className="form-control"
              id="message"
              rows="5"
              placeholder="Write your message here"
              value={formData.Message}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? "Sending..." : "Send Message"}
          </button>
        </form>
      </div>
    </div>
  );
}
